import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import ReactGA from "react-ga4";

//Page
import Register from "./components/page/auth/Register";
import Login from "./components/page/auth/Login";
import Home from "./components/page/Home";
import Product from "./components/page/Product";
import Shop from "./components/page/Shop";
import Cart from "./components/page/Cart";
import Partner from "./components/page/Partner";
import About from "./components/page/About";
import Success from "./components/page/Success";
import Cancel from "./components/page/Cancel";
import HotDeal from "./components/page/HotDeal";
import BestSellers from "./components/page/BestSellers";
import NewArrivals from "./components/page/NewArrivals";
import ShopService from "./components/page/Shop/ShopService";
import LocationShop from "./components/page/LocationShop";
import LocationServiceChecker from "./components/page/LocationServiceChecker";
import MaintenancePage from "./components/page/MaintenancePage";
import LoginByLine from "./components/page/auth/LoginByLine";

import OrderSuccess from "./components/page/user/OrderSuccess";

//Layout
import Navbar from "./components/layouts/Navbar";
import Header from "./components/layouts/Header";
import AdminLayout from "./components/layouts/Adminlayout";

//page admin
import HomeAdmin from "./components/page/admin/Home";
import ManageAdmin from "./components/page/admin/ManageAdmin";
import CreateCaterogy from "./components/page/admin/category/CreateCaterogy";
import UpdateCategory from "./components/page/admin/category/UpdateCategory";
import CreateProduct from "./components/page/admin/product/CreateProduct";
import CreateProductService from "./components/page/admin/product/CreateProductService";
import UpdateProduct from "./components/page/admin/product/UpdateProduct";
import CreateCaterogyService from "./components/page/admin/category/CreateCategooryService";
import AdminChat from "./components/page/admin/AdminChart";
import Orders from "./components/page/admin/Order";
import VisitList from "./components/page/admin/VisitList";
import AdminPanel from "./components/page/admin/AdminPanel";

//page user
import HomeUser from "./components/page/user/Home";
import CheckOut from "./components/page/CheckOut";
import WishList from "./components/page/user/WishList";
import History from "./components/page/user/History";
import ContactShop from "./components/page/ContactShop";
import OederTracking from "./components/page/user/OrderTracking";
import ManageProfile from "./components/page/user/ProfileUsers/ManageProfile";
import Profile from "./components/page/user/ProfileUsers/Profile";
import ChatBox from "./components/page/user/ChatBox";

//page employee branch
import BranchOrderForm from "./components/page/employee/BranchOrderForm";
import BranchOrderList from "./components/page/employee/BranchOrderList";

//page stock
import StockOrders from "./components/order/StockOrder";

//function
import { currentUser } from "./components/function/auth";
//redux
import { useDispatch } from "react-redux";

// Routes
import UserRoute from "./components/routes/UserRoute";
import AdminRoute from "./components/routes/AdminRoute";
import EmployeeRoute from "./components/routes/EmployeeRoute";
import StockRoute from "./components/routes/StockRoute";
import StaffRoute from "./components/routes/StaffRoute";

//Drawer
import SideDrawer from "./components/drawer/SideDrawer";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./components/layouts/Footer";
import AdminChart from "./components/page/admin/AdminChart";
import PromotionManagement from "./components/page/admin/PromotionManagement";
import Promotions from "./components/page/Promotions";
import Promotion from "./components/page/admin/Promotion";

import Rehabilitaion from "./components/page/MenuUserHGome/Rehabilitaion";
import ProDuctMenuHome from "./components/page/MenuUserHGome/Product";
import MedicalSpa from "./components/page/MenuUserHGome/MedicalSpa";
import Aesthetics from "./components/page/MenuUserHGome/Aesthetics";
import AntiAging from "./components/page/MenuUserHGome/AntiAging";
import Hotelsbooking from "./components/page/MenuUserHGome/Hotelsbooking";
import CreateMenu from "./components/page/admin/category/CreateMenu";
import UpdateMenuCategory from "./components/page/admin/category/UpdateMenuCategory";
import SubCategoryList from "./components/page/MenuUserHGome/SubCategoryList";
import ProductList from "./components/page/MenuUserHGome/ProductList";
import ProductDetails from "./components/page/MenuUserHGome/ProductDetails";
import Donate from "./components/card/Donate";
import ShopOrigi from "./components/page/ShopOrigi";
import NavBarHead from "./components/layouts/NavbarHead";
import ResponsiveNavbar from "./components/layouts/ResponsiveNavbar";
import ShopProduct from "./components/page/ShopProduct/ShopProduct";
import ShopServices from "./components/page/ShopProduct/ShopServices";
import ForgotPassword from "./components/page/auth/ForgotPassword";
import ResetPassword from "./components/page/auth/ResetPassword";
import FloatingLoginButton from "./components/layouts/FloatingLoginButton";
import BottomNav from "./components/layouts/BottomNav";
import ShopEmoloyee from "./components/page/employee/ShopEmoloyee";
import LineCallback from "./components/page/auth/lienCallback";
import PartnerAdminDashboard from "./components/page/admin/Partneradmindashboard";
import PartnerLeadAdmin from "./components/page/admin/Partnerleadadmin";
import SsoCallback from "./components/page/auth/SsoCallback";

// const TRACKING_ID = "G-SG32WYQ213";
// ReactGA.initialize(TRACKING_ID);

function App() {
  const dispatch = useDispatch();
  const idtoken = localStorage.token;

  //   const location = useLocation();
  //   useEffect(() => {
  //   const sendPageView = async () => {
  //     try {

  //       await axios.post("http://localhost:4000/api/visit", {
  //         path: location.pathname,
  //         timestamp: new Date().toISOString(),
  //       });
  //     } catch (error) {
  //       console.error("Error tracking visit:", error);
  //     }
  //   };

  //   sendPageView();
  // }, [location]);

  // useEffect(() => {
  //   ReactGA.send({ hitType: "pageview", page: location.pathname });
  // }, [location]);

  useEffect(() => {
    if (!idtoken) return;

    currentUser(idtoken)
      .then((res) => {
        dispatch({
          type: "LOGIN",
          payload: {
            token: idtoken,
            username: res.data.username,
            role: res.data.role,
            _id: res.data._id,
            profileImage: res.data.profileImage,
            branch: res.data.branch,
          },
        });
      })
      .catch((err) => {
        console.log("currentUser error:", err.response?.status);

        // 🔥 สำคัญที่สุด
        if (err.response?.status === 401) {
          localStorage.removeItem("token");

          dispatch({
            type: "LOGOUT",
          });
        }
      });
  }, [dispatch, idtoken]);
  const isMaintenance = process.env.REACT_APP_MAINTENANCE === "true";

  if (isMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <ToastContainer />
      {/* <Header /> */}
      <SideDrawer />
      {/* <h1>360HealthyShop || </h1> */}
      {/* <Register /> */}
      <NavBarHead />
      <ResponsiveNavbar />
      {/* <Navbar/> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login-line360" element={<LoginByLine />} />
        <Route path="/line-callback" element={<LineCallback />} />
        <Route path="/sso/callback" element={<SsoCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/hotdeal" element={<HotDeal />} />
        <Route path="/best-sellers" element={<BestSellers />} />
        <Route path="/new-arrivals" element={<NewArrivals />} />
        <Route path="/product/:id" element={<Product />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop-origi" element={<ShopOrigi />} />
        {/* <Route path="/shop-service" element={<ShopService />} /> */}
        <Route path="/cart" element={<Cart />} />
        <Route path="/contact-shop" element={<ContactShop />} />
        <Route path="/promotion-user" element={<Promotions />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/about" element={<About />} />
        <Route path="/location-shop" element={<LocationShop />} />
        <Route path="/location" element={<LocationServiceChecker />} />
        <Route path="/rehabilitation" element={<Rehabilitaion />} />
        <Route path="/product-menu-userhome" element={<ProDuctMenuHome />} />
        <Route path="/medical-spa" element={<MedicalSpa />} />
        {/* <Route path="/aesthetics" element={<Aesthetics />} /> */}
        <Route path="/anti-aging" element={<AntiAging />} />
        <Route path="/hotels-booking" element={<Hotelsbooking />} />
        <Route path="/aesthetics/:id" element={<SubCategoryList />} />{" "}
        {/* เพิ่ม Route นี้ */}
        {/* <Route path="/products/:subCategoryId" element={<ProductList />} />  */}
        {/* <Route path="/product-menu/:id" element={<ProductDetails />} /> */}
        <Route path="/product-menu/:subId" element={<ProductDetails />} />{" "}
        {/* Use subId to get product details */}
        <Route
          path="/success"
          element={
            <UserRoute>
              <Success />
            </UserRoute>
          }
        />
        <Route path="/cancel" element={<Cancel />} />
        <Route path="/shop-product" element={<ShopProduct />} />
        <Route path="/shop-services" element={<ShopServices />} />

        <Route
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route path="/admin/index" element={<HomeAdmin />} />
          <Route path="/admin/manage-admin" element={<ManageAdmin />} />
          <Route path="/admin/create-category" element={<CreateCaterogy />} />
          <Route path="/admin/create-menu" element={<CreateMenu />} />
          <Route
            path="/admin/create-category-service"
            element={<CreateCaterogyService />}
          />
          <Route
            path="/admin/update-category/:id"
            element={<UpdateCategory />}
          />
          <Route
            path="/admin/update-category-menu/:id"
            element={<UpdateMenuCategory />}
          />
          <Route path="/admin/create-product/" element={<CreateProduct />} />
          <Route
            path="/admin/create-product-service/"
            element={<CreateProductService />}
          />
          <Route path="/admin/promotion-product/" element={<Promotion />} />
          <Route path="/admin/update-product/:id" element={<UpdateProduct />} />
          <Route path="/admin/orders" element={<Orders />} />
          <Route path="/admin/visit" element={<VisitList />} />
          <Route path="/admin/chart-sell" element={<AdminChart />} />
          <Route path="/admin/panel" element={<AdminPanel />} />
          <Route path="/admin/partner" element={<PartnerAdminDashboard />} />
          <Route path="/admin/partner-leads" element={<PartnerLeadAdmin />} />
        </Route>
        
        <Route
          path="/admin/branch"
          element={
            <StaffRoute>
              <BranchOrderForm />
            </StaffRoute>
          }
        />
        <Route
          path="/admin/branch-list"
          element={
            <StaffRoute>
              <BranchOrderList />
            </StaffRoute>
          }
        />
        
        <Route
          path="/employ-shop/"
          element={
            <EmployeeRoute>
              <ShopEmoloyee />
            </EmployeeRoute>
          }
        />
        {/* Stock Routes*/}
        <Route
          path="/stock/orders"
          element={
            <StockRoute>
              <StockOrders />
            </StockRoute>
          }
        />
        <Route
          path="/user/index"
          element={
            <UserRoute>
              <HomeUser />
            </UserRoute>
          }
        />
        <Route
          path="/checkout"
          element={
            <UserRoute>
              <CheckOut />
            </UserRoute>
          }
        />
        <Route
          path="/user/wishlist"
          element={
            <UserRoute>
              <WishList />
            </UserRoute>
          }
        />
        <Route
          path="/user/history"
          element={
            <UserRoute>
              <History />
            </UserRoute>
          }
        />
        <Route
          path="/user/order-tracking"
          element={
            <UserRoute>
              <OederTracking />
            </UserRoute>
          }
        />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route
          path="/profile"
          element={
            <UserRoute>
              <Profile />
            </UserRoute>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <UserRoute>
              <ManageProfile />
            </UserRoute>
          }
        />
        <Route
          path="/user/chat"
          element={
            <UserRoute>
              <ChatBox />
            </UserRoute>
          }
        />
      </Routes>
      <FloatingLoginButton />
      <Footer />
      <BottomNav />
    </div>
  );
}

export default App;
